import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';

let url = process.env.REACT_APP_API_URL;

const triggerBlobDownload = (blob, filename) => {
  const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};

export const intermediaryComissionService = {
  getList: async (params) => {
    const response = await authInstance
      .get(
        `${url}/intermediaryComission/?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => response)
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getDetail: async (params) => {
    const response = await authInstance
      .get(
        `${url}/intermediaryComission/detail?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => response)
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  calculate: async (body) => {
    const response = await authInstance
      .post(`${url}/intermediaryComission/calculate`, body)
      .then(async (response) => response)
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  downloadZip: async (params) => {
    try {
      const response = await authInstance.get(
        `${url}/intermediaryComission/zip?` +
          new URLSearchParams(filterParams(params)),
        { responseType: 'blob' }
      );

      if (response?.status === 200) {
        triggerBlobDownload(
          response.data,
          `comisiones-intermediarios-${params.startDate}_${params.endDate}.zip`
        );
        return { status: 200 };
      }

      return { status: response?.status, message: 'Error al descargar el zip' };
    } catch (error) {
      console.log('error', error);
      return { status: 500, message: 'Error al descargar el zip' };
    }
  },

  downloadPdf: async (params) => {
    try {
      const response = await authInstance.get(
        `${url}/intermediaryComission/pdf?` +
          new URLSearchParams(filterParams(params)),
        { responseType: 'blob' }
      );

      if (response?.status === 200) {
        triggerBlobDownload(
          response.data,
          `comision-intermediario-${params.startDate}_${params.endDate}.pdf`
        );
        return { status: 200 };
      }

      return { status: response?.status, message: 'Error al descargar el PDF' };
    } catch (error) {
      console.log('error', error);
      return { status: 500, message: 'Error al descargar el PDF' };
    }
  },
};
